/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

 import FDRequest from 'fd-request'
 import { AxiosError } from 'axios'
 import store from '@/store'
 import { Toast } from 'vant'
 import router from '@/router'
 /* h5对接原生 */
 import Bridge from '@/utils/bridge'
 // @ts-ignore
 import { getAuthHeader } from '@/utils/request'
 import { VueConstructor } from 'vue'
 import { VueAxios } from '@/utils/axios'
 import { ContentType, AuthHeader, NotLoginAuthHeaderVal } from '@/constant/common'
import { chooseUserType } from '@/api/creatCompany'
import { handleLogout } from '@/utils/util'
 // 项目管理 ID
 export const ACCESS_KEY_ID = process.env.VUE_APP_ACCESS_KEY_ID
 // 项目管理秘钥
 export const ACCESS_KEY_SECRET = process.env.VUE_APP_ACCESS_KEY_SECRET
 
 export interface Parameter {
     [prop: string]: any;
 }
 
 export const assignParams = () => {
   return {
     companyId: store.state.user.info.companyId
   }
 }
 
 /**
  * 过滤请求参数
  * @param params
  */
 export function filterQueryParams (params: Record<string, any>) {
   Object.keys(params).forEach(k => {
     if (params[k] === '' || params[k] == null) {
       delete params[k]
     }
   })
   return params
 }
 
 const toastRequest = Toast
 const toastTip = Toast
 
 const api = {
     imgCaptcha: '/code/image',
     Logout: '/auth/logout',
     ForgePassword: '/auth/forge-password',
     UserInfo: '/user/info',
 }
 
 const err = function(error: AxiosError) {
     store.commit('CLEAR_LOADING')
     if (error.response) {
         const data = error.response.data
         // 处理登陆失效
         if (
             error.response.status === 401 &&
             !(data.result && data.result.isLogin)
         ) {
          //  toastTip.fail('登录信息已过期，请重新登录')
          //  setTimeout(() => {
          //    Bridge.callHandler('logout')
          //  }, 2000);

          // 调原生获取新token
          // Bridge.callHandler('getAccessToken', {}, (token: string) => {
          //   console.log('%c 🥐 token: ', 'font-size:12px;background-color: #7F2B82;color:#fff;', token);
          //   // 更新token
          //   store.commit('SET_TOKEN', token)
          //   // 重新请求
          //   service(error.config as any)
          // })
          const userId = store.state.user.info?.userId
          if (userId) {
            const params = {
              oldUserId: userId, // 用户编号(切换前)
              userId // 用户编号(切换后)
            }
            chooseUserType(params).then((res) => {
              const { data } = res
              // 更新token
              store.commit('SET_TOKEN', data.access_token)
              // 重新请求
              service(error.config as any)
            })
          }
         } else if (error.response.status === 500) {
             toastRequest.clear()
             // router.push('/500')
         } else if (error.response.status === 403) {
             toastTip.fail(data.message)
         } else if (error.code === '000086') { // 当前登录用户已禁用,此时调用原生退出登录方法
             toastTip.fail('当前登录用户已禁用')
            //  Bridge.callHandler('logout')
             handleLogout()
         } else {
             toastTip.fail(data.msg || '网络繁忙，请稍后再试')
         }
         // 存储请求错误信息
         require('@/plugins/error.ts').errorHandler(error, 'request-error')
     }
     return Promise.reject(error)
 }
 
 const axios = new FDRequest({
     mode: process.env.NODE_ENV as 'production',
     encrypt: false,
     cancelRepeatRequest: true,
     config: {
         baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
         timeout: 180000, // 请求超时时间
         headers: {
             clientId: 'web',
             [ContentType]: 'application/json',
             from:2 //解决移动端和pc端可以同时在线问题
         },
     },
     errorHandle: err,
 })
 
 const exportAxios = new FDRequest({
     mode: process.env.NODE_ENV as 'production',
     encrypt: false,
     cancelRepeatRequest: true,
     config: {
         baseURL: process.env.VUE_APP_MANAGE_API_BASE_URL,
         timeout: 180000, // 请求超时时间
         responseType: 'arraybuffer',
         headers: {
             clientId: 'web',
             [ContentType]: 'application/json',
             access_key_id: ACCESS_KEY_ID,
             access_key_secret: ACCESS_KEY_SECRET,
             from:2 //解决移动端和pc端可以同时在线问题
         },
     },
     errorHandle: err,
 })
 
 const axiosAPIUrl = new FDRequest({
     mode: process.env.NODE_ENV as 'production',
     encrypt: false,
     cancelRepeatRequest: true,
     config: {
         baseURL: process.env.VUE_APP_MANAGE_API_BASE_URL,
         timeout: 180000, // 请求超时时间
         headers: {
             clientId: 'web',
             [ContentType]: 'application/json',
             access_key_id: ACCESS_KEY_ID,
             access_key_secret: ACCESS_KEY_SECRET,
             from:2 //解决移动端和pc端可以同时在线问题
         },
     },
     errorHandle: err,
 })
 
 /**
  * 设置拦截器
  * @param axiosSet FDRequest实例
  */
 const setInterceptor = function(axiosSet: FDRequest) {
     axiosSet.setRequestInterceptor(async(config: any) => {
         /* 添加加載中彈窗提示 start */
         let showLoading = false
         if (config.hasOwnProperty('extraParams')) {
             showLoading = config.extraParams.hasOwnProperty('showLoading')
                 ? config.extraParams.showLoading
                 : true
         } else {
             showLoading = true
         }
         if (showLoading) {
           // 调用原生开启动画
           store.commit('ADD_LOADING')
         }
         /* 添加加載中彈窗提示 end */
 
         // 移除传参中值为null或者undefined或者空字符串的属性
         if (config.params) {
             config.params = Object.keys(config.params).reduce((p, c) => {
                 if (config.params[c] || config.params[c] === 0) {
                     // @ts-ignore
                     p[c] = config.params[c]
                 }
                 return p
             }, {})
         }
         // @ts-ignore
         const token = store.state.user.token
         // @ts-ignore
 
         const userId = store.state.user.info.userId
         config.headers.userId = userId
         config.headers.opUser = userId
         if (token && config.headers[AuthHeader] != NotLoginAuthHeaderVal) {
             config.headers = {...config.headers, ...getAuthHeader(token)} // 让每个请求携带自定义 token 请根据实际情况自行修改
         }
         return config
     })
 
     axiosSet.setResponseInterceptor(async(response: any) => {
        //  console.log(response)
         /* 移除加載中彈窗提示 start */
         let showLoading = false
         if (response.config.hasOwnProperty('extraParams')) {
             showLoading = response.config.extraParams.hasOwnProperty('showLoading')
                 ? response.config.extraParams.showLoading
                 : true
         } else {
             showLoading = true
         }
         // 调用原生清除动画
         if (showLoading) {
           store.commit('SUB_LOADING')
         }
         /* 移除加載中彈窗提示 end */
 
         const result = response
         const code = result.data.code
         if (code && code !== '000000' && code !== '000002' && code !== '000086' && code !== '000003') {
            if (!result.config.headers.toastTip) toastTip.fail(result.data.msg)
             /* 存储异常code码错误日志 start */
             let error: AxiosError = new Error(result.data.msg) as AxiosError
             error.response = result
             error.code = code
             // 存储请求错误信息
             require('@/plugins/error.ts').errorHandler(error, 'request-error')
             /* 存储异常code码错误日志 end */
             throw result
         } else if (code === '000086') { // 当前登录用户已禁用,此时调用原生退出登录方法
             toastTip.fail('当前登录用户已禁用')
            //  Bridge.callHandler('logout', {msg: result.data.msg})
             handleLogout()
         }
 
         // 如果是文件流的话就直接返回请求响应
         if (result.data instanceof ArrayBuffer) {
             return result
         }
         return result.data
     })
 }
 
 setInterceptor(axios)
 setInterceptor(axiosAPIUrl)
 setInterceptor(exportAxios)
 
 const service = axios.service
 const serviceAPIUrl = axiosAPIUrl.service
 const exportService = exportAxios.service
 
 const installer = {
     vm: {},
     install (Vue: VueConstructor) {
         Vue.use(VueAxios, service)
     },
 }
 
 export {
     installer as VueAxios,
     service as axios,
     serviceAPIUrl as axiosAPIUrl,
     exportService as exportAxios,
     api,
 }
 